import Bowser from "bowser";
import { DateUtils } from "./_DateUtils";

/**
 * Helper functions for forms
 */
class FormUtils {
    /* **************** */
    /* Needed statics */
    /* **************** */

    /**
     * calculate sum of ranges
     * @param {array} range_inputs
     * @return {number}
     */
    static rangesSum(range_inputs) {
        let sum = 0;
        range_inputs.forEach((range) => {
            sum += parseInt(range.value, 10);
        });
        return sum;
    }

    /* ************** */
    /* Main statics */
    /* ************** */

    /**
     * check the given form is valid
     * @param {HTMLElement} form
     * @return {boolean}
     */
    static validateForm(form) {
        let is_valid = true;
        form.classList.add("was-validated");
        const password_confirm_field = $(form).children(
            "#password_confirmation"
        );
        if (password_confirm_field.length > 0) {
            const password_field = $(form).children("#password_confirmation");
            if (password_field.val() !== password_confirm_field.val()) {
                password_confirm_field[0].setCustomValidity(
                    "تکرار رمز عبور با رمز عبور یکسان نیست"
                );
                is_valid = false;
            }
        }

        const $selects = $(form).find("select").filter("[required]");
        $selects.each(function () {
            const val = this.value;
            if (!val || val.length < 1) {
                this.setCustomValidity("گزینه انتخاب شده معتبر نیست");
                is_valid = false;
            } else {
                this.setCustomValidity("");
            }
        });

        if (!form.checkValidity()) {
            is_valid = false;
        }

        return is_valid;
    }

    /**
     * Add events to ranges in page
     */
    static handleRanges() {
        const range_inputs = document.querySelectorAll("input[type=range]");
        range_inputs.forEach((range) => {
            const labels = document.querySelectorAll(
                `.range_val[for="${range.id}"]`
            );

            labels.forEach((label) => {
                label.textContent =
                    +range.value > 0 ? `%${range.value}` : range.value;
            });

            range.addEventListener("input", (event) => {
                const val = event.target.value;

                labels.forEach((label) => {
                    label.textContent = +val > 0 ? `%${val}` : val;
                });
            });
        });
    }

    /**
     * checks balance of ranges in container
     * @param {string} ranges_container
     */
    static checkRangesBalanceValid(ranges_container) {
        const container = document.querySelector(ranges_container);
        const range_inputs = container.querySelectorAll("input[type=range]");

        range_inputs.forEach((range) => {
            range.addEventListener("input", () => {
                const sum = this.rangesSum(range_inputs);
                if (sum !== 100) {
                    // changeotherRanges(sum, event.targer, range_inputs);
                }
            });
        });
    }

    /**
     * Add google captcha to current page
     */
    static addGoogleCaptcha() {
        $("#btn_submit").prop("disabled", true);
        const script = document.createElement("script");
        script.onload = function () {
            grecaptcha.ready(() => {
                grecaptcha
                    .execute("6LeyIJYcAAAAANSGplphOu4ro574pNGLAOWEf57-")
                    .then((token) => {
                        document.getElementsByName(
                            "g-recaptcha-response"
                        )[0].value = token;
                        $("#btn_submit").prop("disabled", false);
                    });
            });
        };
        script.src =
            "https://www.google.com/recaptcha/api.js?render=6LeyIJYcAAAAANSGplphOu4ro574pNGLAOWEf57-";
        document.head.appendChild(script);
    }

    /**
     * Renew captcha token
     *
     * @return {Promise}
     */
    static renewGoogleCaptcha() {
        return grecaptcha
            .execute("6LeyIJYcAAAAANSGplphOu4ro574pNGLAOWEf57-")
            .then((token) => {
                document.getElementsByName("g-recaptcha-response")[0].value =
                    token;
                $("#btn_submit").prop("disabled", false);
            });
    }

    /**
     * create a header containing google captcha
     * @return {{captcha} | null}
     */
    static captchaHeader() {
        if ($("#form_google").val()) {
            return {
                captcha: $("#g-recaptcha-response").val(),
            };
        }
        return null;
    }

    /**
     * Returns user browser info
     * @return {{browserName: string, browserVersion: string, osName:string, osVersion:string}}
     */
    static getBrowserInfo() {
        const deatils = Bowser.parse(window.navigator.userAgent);
        return {
            browserName: deatils.browser.name,
            browserVersion: deatils.browser.version,
            osName: deatils.os.name,
            osVersion: deatils.os.versionName,
        };
    }

    /**
     *checks tour status
     *
     * @static
     * @param {string} key
     * @return {boolean}
     * @memberof FormUtils
     */
    static getTourStatus(key) {
        const done_tour = localStorage.getItem(key) === "1";
        const user_data = sessionStorage.getItem("UD")
            ? JSON.parse(sessionStorage.getItem("UD"))
            : null;
        const accept_date =
            user_data && user_data.date ? new Date(user_data.date) : null;
        const is_before = DateUtils.isBeforeToday(accept_date);

        if (done_tour) {
            return true;
        } else {
            if (is_before) {
                return true;
            } else {
                return false;
            }
        }
    }
}

export default FormUtils;
export { FormUtils };
